import { ErrorMessage } from "formik";
import React, { useEffect } from "react";
import { formatCurrency } from "../../utils";

export default function CurrencyInput({ field, form, ...props }) {

  useEffect(() => {
    if (props.resetValue) {
      form.setFieldValue(field.name, null)
    }
  }, [props.resetValue]);

  return (
    <div className={"form-group input-group-lg col-md-" + (props.colNumber || 4)}>
      <label className="text-black font-w600">
        {props.label}
        {props.required ? "*" : ""}
      </label>
      { props.isSignVisible && <span class="input-group-text rounded-lg" style={{ float: 'right', marginBottom: '-40px', marginTop: '31px' }}>₺</span> }
      <input
        // type="number"
        className="form-control"
        placeholder={props.placeholder ? props.placeholder : props.label}
        style={{ height: "calc(1.5em + 1rem + -4px)" }}
        onKeyUp={(e) => {
          form.setFieldValue(field.name,formatCurrency(e)) }}
        {...field}
        {...props}
        value={
          field.value !== undefined ? field.value : ""
        }
      />
      <ErrorMessage
        name={field.name}
        render={(msg) => (
          <span className="text-danger">
            <small>*{msg}</small>
          </span>
        )}
      />
    </div>
  );
}
